export default {
  BT_HDP: "핸디캡 | 핸디캡",
  BT_OU: "오버/언더 | 오버/언더",
  BT_ML: "머니라인",
  BT_1X2: "1X2",
  BT_1X2HDP: "3방식 핸디캡",
  BT_CS: "정확한 득점",
  BT_OE: "홀수/짝수 | 홀수/짝수",
  BT_DC: "더블 찬스",
  BT_HTFT: "전반전 경기/전후반경기",
  BT_FGLG: "첫 골/마지막 골",
  BT_TG: "총 득점",
  BT_OR: "승자 예상 배팅",
  BT_ORZ: "승자 예상 배팅",

  BT_ANB: "Away No Bet",
  BT_BS: "양 팀 득점/한 팀 득점/득점 없음",
  BT_CL: "클린 시트",
  BT_DNB: "무승부 시 베팅 무효",
  BT_DNBH: "전후반경기 무승부 시 베팅 무효",
  BT_HNB: "Home No Bet",
  BT_TWTN: "완봉승",

  BT_HDPF: "풀타임 핸디캡 | 풀타임 핸디캡",
  BT_OUF: "풀타임 오버/언더 | 풀타임 오버/언더",
  BT_MLF: "전후반경기 머니라인",
  BT_1X2F: "풀타임 1X2",
  BT_1X2HDPF: "전후반경기 3방식 핸디캡",
  BT_CSF: "전후반경기 정확한 득점",
  BT_OEF: "전후반경기 홀수/짝수",
  BT_DCF: "전후반경기 더블 찬스",
  BT_FGLGF: "전후반경기 첫 골 /마지막 골",
  BT_TGF: "전후반경기 총 득점",

  BT_HDPH: "전반전 핸디캡 | 전반전 핸디캡",
  BT_OUH: "전반전 오버/언더 | 전반전 오버/언더",
  BT_MLH: "전반전 머니라인",
  BT_1X2H: "전반전 1X2",
  BT_1X2HDPH: "전반전 3방식 핸디캡",
  BT_CSH: "전반전 정확한 득점",
  BT_OEH: "전반전 홀수/짝수",
  BT_DCH: "전반전 더블 찬스",
  BT_FGLGH: "전반전 첫 골 /마지막 골",
  BT_TGH: "전반전 총 득점",
  BT_O: "오버",
  BT_U: "언더",

  BT_HDPOU: "핸디캡&오버/언더",
  BT_PARLAY: "믹스 팔레이",
  BT_FT: "전후반경기. ",
  BT_1H: "전반전. ",
  BT_2H: "후반전. ",

  BT_FG: "첫 득점",
  BT_LG: "마지막 득점",
  BT_HFG: "홈팀첫골",
  BT_AFG: "원정팀첫골",
  BT_HLG: "홈팀마지막골",
  BT_ALG: "원정팀마지막골",
  BT_NG: "노 골",
  BT_HY: "홈 팀 예스",
  BT_HN: "홈 팀 노",
  BT_AY: "원정팀 예스",
  BT_AN: "원정팀 노",
  BT_H: "홈팀",
  BT_A: "원정팀",
  BT_D: "무승부",
  BT_HD_DC: "홈 혹은 무승부",
  BT_HA_DC: "홈 혹은 원정",
  BT_DA_DC: "원정팀 혹은 무승부",
  BT_HH: "홈/홈",
  BT_HD: "홈/무승부",
  BT_HA: "홈/원정팀",
  BT_DH: "무승부/홈",
  BT_DD: "무승부/무승부",
  BT_DA: "무승부/원정팀",
  BT_AH: "원정팀/홈",
  BT_AD: "원정팀/무승부",
  BT_AA: "원정팀/원정팀",

  BT_Y: "예스",
  BT_N: "노",

  BT_LIVE: "라이브",
  BT_HT: "H.TIME",
  BT_DELAYED: "지연",
  BT_PEN: "PEN",

  BT_FT1: "풀타임.1",
  BT_FT2: "풀타임.2",
  BT_FTX: "풀타임.X",
  BT_HT1: "전반전.1",
  BT_HT2: "전반전.2",
  BT_HTX: "전반전.X",

  BT_BOTH: "양팀",
  BT_ONE: "한팀",

  BS_HDP: "풀타임 핸디캡",
  BS_HDPH: "전반전 핸디캡",
  BS_OU: "풀타임 오버/언더",
  BS_OUH: "전반전 오버/언더",
  BS_OE: "전후반경기 홀수/짝수",
  BS_OEH: "전반전 홀수/짝수",
  BS_1X2: "풀타임 1X2",
  BS_1X2H: "전반전 1X2",
  BS_ML: "전후반경기 머니라인",
  BS_MLH: "전반전 머니라인",
  BS_1X2HDP: "전후반경기 3방식 핸디캡",
  BS_1X2HDPH: "전반전 3방식 핸디캡",
  BS_CS: "전후반경기 정확한 득점",
  BS_CSH: "전반전 정확한 득점",
  BS_DC: "전후반경기 더블 찬스",
  BS_DCH: "전반전 더블 찬스",
  BS_FGLG: "전후반경기 첫 골 /마지막 골",
  BS_FGLGH: "전반전 첫 골 /마지막 골",
  BS_TG: "전후반경기 총 득점",
  BS_TGH: "전반전 총 득점",
  BS_ANB: "Away No Bet",
  BS_HTFT: "전반전 경기/전후반경기",
  BS_BS: "양 팀 득점/한 팀 득점/득점 없음",
  BS_CL: "클린 시트",
  BS_DNB: "무승부 시 베팅 무효",
  BS_DNBH: "전후반경기 무승부 시 베팅 무효",
  BS_HNB: "Home No Bet",
  BS_TWTN: "완봉승",
  BS_OR: "승자 예상 배팅",
  BS_ORZ: "승자 예상 배팅",
  
  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",
  LOT_FT: "FT",
  LOT_HT: "HT",

  BT_ALLBT: "All Bet Type",
  _1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "K.O. By",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "D",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "WIN",
  GH_1X20: "WIN",
  GH_1X2HDP: "PLACE/SHOW",
  GH_1X2HDP2: "PLACE",
  GH_1X2HDP4: "SHOW",
  GH_OVER: "OVER (4,5,6)",
  GH_UNDER: "UNDER (1,2,3)",
  GH_ODD: "ODD (1,3,5)",
  GH_EVEN: "EVEN (2,4,6)",
  GH_OU1: "OVER (4,5,6)",
  GH_OU2: "UNDER (1,2,3)",
  GH_OE1: "ODD (1,3,5)",
  GH_OE2: "EVEN (2,4,6)",

  ROOM_A: "Open",
  ROOM_0: "Active",
  ROOM_1: "Closed",
  ROOM_2: "Cancel",
  ROOM_3: "Ended",
  ROOM_4: "Stop Betting",
  ROOM_10: "All",

  ROOM_T0: "All",
  ROOM_T1: "Public Room",
  ROOM_T2: "Private Room",
  ROOM_T3: "Play to Earn",

  joinRoom1: "Join Public Room",
  joinRoom2: "Join Private Room",
  joinRoom3: "Join Play Room",
  createRoom1: "Create Public Room",
  createRoom2: "Create Private Room",
  createRoom3: "Create Play Room",
  Champion: "Champion",
  FirstRunnerUp: "First Runner Up",
  SecondRunnerUp: "Second Runner Up",

  BT_OEHM: "Home Odd/Even | Home O/E",
  BT_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BT_OEAW: "Away Odd/Even | Away O/E",
  BT_OEAWH: "FH. Away Odd/Even | FH. Away O/E",

  BS_OEHM: "FT. Home Odd/Even | FT. Home O/E",
  BS_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BS_OEAW: "FT. Away Odd/Even | FT. Away O/E",
  BS_OEAWH: "FH. Away Odd/Even | FH. Away O/E",
  
  MB_OVER: "OVER (4,5,6)",
  MB_UNDER: "UNDER (1,2,3)",
  MB_ODD: "ODD (1,3,5)",
  MB_EVEN: "EVEN (2,4,6)",
};